const ResponsivePrimaryNav = ({ children, className = "" }) => (
  <div
    className={`sticky top-0 z-30 flex flex-col gap-3 border-b bg-white px-4 py-3 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8 lg:py-5 [&>div]:min-w-0 [&>div]:flex-wrap max-lg:[&>div]:w-full max-lg:[&>div]:justify-start [&_.ui-button]:w-auto [&_.ui-button]:text-xs ${className}`}
  >
    {children}
  </div>
);

export { ResponsivePrimaryNav };
